'use client';

import { Text } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import type { FormBaseInputProps, FormValues } from '../../../types';
import { FormField } from '../../wrapper';

export type StaticTextProps<T> = FormBaseInputProps<T>;

export const StaticText = <T extends FormValues>({
	helperText,
	label,
	name,
	optionalText,
	required,
}: StaticTextProps<T>) => {
	const { watch } = useFormContext<T>();
	const value = watch(name);

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<Text>
				{value as string}
			</Text>
		</FormField>
	);
};
